import React__default from 'react';
import { PortalTargetProvider } from './3b439fae09430a89bf9bbc95661684ba0b31a690249158604440a1f4e9233a91.cfe-internal.js';
import { TranslationProvider } from '../../utils/Translation/42d814874415aa7ed68787d683b3358e9f7a082e7134e08a169c9fab9c21cc57.cfe-internal.js';

var UIProvider = function UIProvider(_ref) {
  var children = _ref.children,
      portalTarget = _ref.portalTarget,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config;
  return /*#__PURE__*/React__default.createElement(TranslationProvider, {
    localizedText: config === null || config === void 0 ? void 0 : config.localizedText
  }, /*#__PURE__*/React__default.createElement(PortalTargetProvider, {
    value: portalTarget !== null && portalTarget !== void 0 ? portalTarget : null
  }, children));
};

export { UIProvider };
